import { useTranslation } from 'react-i18next';

export function BusinessSection() {
  const { t } = useTranslation();
  
  const businesses = [
    {
      icon: 'ri-smartphone-line',
      title: t('business_new_title'),
      description: t('business_new_desc'),
      image: 'https://static.readdy.ai/image/efe453aa8b08959c7487fe5d411998a7/f7a924f4ebe4d3faf433869a4c538f22.webp',
      features: [t('business_new_feature_1'), t('business_new_feature_2'), t('business_new_feature_3')]
    },
    {
      icon: 'ri-recycle-line',
      title: t('business_resource_title'),
      description: t('business_resource_desc'),
      image: 'https://static.readdy.ai/image/efe453aa8b08959c7487fe5d411998a7/bbe359dff670ec75865f97d65b8ae6f7.png',
      features: [t('business_resource_feature_1'), t('business_resource_feature_2'), t('business_resource_feature_3')]
    },
    {
      icon: 'ri-refresh-line',
      title: t('business_used_title'),
      description: t('business_used_desc'),
      image: 'https://static.readdy.ai/image/efe453aa8b08959c7487fe5d411998a7/547ce1e0569d7c0ceb1b5ccfc23142c9.jpeg',
      features: [t('business_used_feature_1'), t('business_used_feature_2'), t('business_used_feature_3')]
    }
  ];

  return (
    <section id="business" className="py-24 bg-gray-50">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            {t('business_title')}<span className="text-blue-600">{t('business_title_highlight')}</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            {t('business_subtitle')}<strong>{t('business_subtitle_bold_1')}</strong>、<strong>{t('business_subtitle_bold_2')}</strong>、<strong>{t('business_subtitle_bold_3')}</strong>{t('business_subtitle_end')}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {businesses.map((business, index) => (
            <div 
              key={index}
              className="bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 group"
            >
              {/* Product Image */}
              <div className="aspect-[3/2] overflow-hidden bg-gray-100">
                <img 
                  src={business.image}
                  alt={business.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              
              {/* Content */}
              <div className="p-8">
                <div className="w-14 h-14 flex items-center justify-center bg-blue-100 text-blue-600 rounded-xl mb-6 group-hover:bg-blue-600 group-hover:text-white transition-all duration-300">
                  <i className={`${business.icon} text-3xl`}></i>
                </div>
                
                <h3 className="text-2xl font-bold text-gray-900 mb-4">{business.title}</h3>
                <p className="text-gray-600 leading-relaxed mb-6">{business.description}</p>
                
                <div className="flex flex-wrap gap-2">
                  {business.features.map((feature, idx) => (
                    <span 
                      key={idx}
                      className="px-3 py-1 bg-blue-50 text-blue-600 rounded-full text-sm font-medium"
                    >
                      {feature}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Global Coverage */}
        <div className="mt-16 bg-gradient-to-r from-blue-600 to-blue-700 rounded-2xl p-12 text-white">
          <div className="text-center mb-12">
            <h3 className="text-3xl font-bold mb-4">{t('business_coverage_title')}</h3>
            <p className="text-blue-100 text-lg">{t('business_coverage_subtitle')}</p>
          </div>
          
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
            {[
              { region: t('business_region_europe'), icon: 'ri-earth-line', desc: t('business_region_europe_en') },
              { region: t('business_region_dubai'), icon: 'ri-building-line', desc: t('business_region_dubai_en') },
              { region: t('business_region_latam'), icon: 'ri-map-pin-line', desc: t('business_region_latam_en') },
              { region: t('business_region_sea'), icon: 'ri-global-line', desc: t('business_region_sea_en') }
            ].map((region, index) => (
              <div key={index} className="text-center">
                <div className="w-16 h-16 flex items-center justify-center bg-white/20 rounded-full mx-auto mb-4">
                  <i className={`${region.icon} text-3xl`}></i>
                </div>
                <h4 className="text-xl font-bold mb-2">{region.region}</h4>
                <p className="text-blue-100 text-sm">{region.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
